import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="error-boundary" role="alert">
        <p className="error-boundary__title">The signal was interrupted.</p>
        <p className="error-boundary__message">
          Something went wrong while loading this page. Please refresh and try again.
        </p>
        <button
          className="error-boundary__action"
          type="button"
          onClick={() => window.location.reload()}
        >
          Refresh page
        </button>
      </div>
    );
  }
}
